export const navList = ["About Us", "Products", "Our Team", "Blogs", "Media"];

export const firstComapnyList = ["Impact", "careers", "Women in Real Estate", "Refferal Partners ", "Vendors"];

export const secondComapnyList = ["Privacy Policy", "Cookies Policy", "Terms and Conditions"];

export const SideBar = ["Dashboard", "Customers", "Properties", "Orders", "Call Back", "Payments", "IA-AI"];